/**
 * Logger utility that respects NODE_ENV
 * In production, only errors are logged. In development, all logs are shown.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  /**
   * Log debug information (only in development)
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log informational messages (only in development)
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Log warnings (always shown, but can be filtered in production if needed)
   */
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
    // In production, you might want to send warnings to error tracking service
  },

  /**
   * Log errors (always shown, as these are important)
   */
  error: (...args: any[]) => {
    console.error(...args);
    // In production, you might want to send errors to error tracking service
  },

  /**
   * Log trace information (only in development)
   */
  trace: (...args: any[]) => {
    if (isDevelopment) {
      console.trace(...args);
    }
  },
};
